const DownloadAppHome = ({ size = 16 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M7.66875 11.8469C7.7625 11.9594 7.88125 12 8 12C8.11875 12 8.23731 11.958 8.33187 11.8735L12.8319 7.87353C13.0379 7.69044 13.0575 7.37416 12.8739 7.16791C12.6903 6.96088 12.372 6.94184 12.1679 7.12641L8.5 10.3875V0.5C8.5 0.223625 8.275 0 8 0C7.725 0 7.5 0.223625 7.5 0.5V10.3875L3.83125 7.125C3.62812 6.94062 3.30938 6.9625 3.125 7.16875C2.9425 7.34687 2.96188 7.69063 3.16875 7.84688L7.66875 11.8469ZM14 10H12.5C12.2239 10 12 10.2238 12 10.5C12 10.7761 12.2239 11 12.5 11H14C14.5522 11 15 11.4478 15 12V14C15 14.5522 14.5522 15 14 15H2C1.44781 15 1 14.5522 1 14V12C1 11.4478 1.44781 11 2 11H3.5C3.775 11 4 10.775 4 10.5C4 10.225 3.775 10 3.5 10H2C0.895313 10 0 10.8953 0 12V14C0 15.1047 0.895313 16 2 16H14C15.1047 16 16 15.1047 16 14V12C16 10.8969 15.1031 10 14 10ZM13.75 13C13.75 12.5859 13.4141 12.25 13 12.25C12.5859 12.25 12.25 12.5859 12.25 13C12.25 13.4141 12.5859 13.75 13 13.75C13.4141 13.75 13.75 13.4156 13.75 13Z"
      fill="#374151"
    />
  </svg>
);

export default DownloadAppHome;
